// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./abhaTokenViewTableCell.scss";
import TitleSubtitleCard from "../../../common/Modules/TitleSubtitleCard";
import { ABHA_STATUS } from "../../constant";
import PrimaryButton from "../../../common/Buttons/PrimaryButton";
import moment from "moment";

// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const AbhaTokenViewTableCell = (props) => {
  // const declarations ⇒
  const { abhaTokenList, onhandleViewDetails } = props;

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  const getTitleStyle = (appnt) => {
    let style = {};
    ABHA_STATUS.forEach((st) => {
      if (st.name === appnt) {
        style = {
          color: st.color,
          backgroundColor: st.backgroundColor,
          border: "1px solid " + st.color,
          width: "77px",
          fontSize: "9px",
          height: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        };
      }
    });
    return style;
  };

  // Actions ⇒

  // create UI ⇒

  const abhaTokenViewTableCellMobileUi = () => {
    return (
      <div className="abha-token-view-table-cell-mobile-container">
        {abhaTokenList.map((item, index) => (
          <div
            className="abha-token-view-table-cell-mobile-wrapper"
            key={index}
          >
            <div className="atvt-token-name-container">
              <div className="atvt-token-no-wrapper">
                <div className="atvt-heading">TOKEN NUMBER</div>
                <div className="atvt-value">{item.token_number}</div>
              </div>
              <div className="atvt-patient-name-wrapper">
                <div className="atvt-heading">PATIENT NAME</div>
                <div className="atvt-value">{item.name}</div>
              </div>
            </div>
            <div className="atvt-token-name-container">
              <div className="atvt-status-wrapper">
                <div className="atvt-heading">STATUS</div>
                <div className="atvt-value">
                  <TitleSubtitleCard
                    titleStyle={getTitleStyle(item.status)}
                    title={item.status}
                  />
                </div>
              </div>
              <div className="atvt-view-details-btn-wrapper">
                {item.status === "TOKEN ACTIVE" && (
                  <div className="atvcw-view-details-btn">
                    <PrimaryButton
                      title="View details"
                      handleButtonClick={() => onhandleViewDetails(item)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const abhaTokenViewTableCellUi = () => {
    return (
      <>
        {abhaTokenList.map((item, index) => (
          <div className="abha-token-view-table-cell-wrapper" key={index}>
            <div className="atvcw-title-token-no">{item.token_number}</div>
            <div className="atvcw-title-name-status">{item.name}</div>
            <div className="atvcw-title-name-status">
              <TitleSubtitleCard
                titleStyle={getTitleStyle(item.status)}
                title={item.status}
              />
            </div>
            <div className="atvcw-title-profile-shared-date">
              {moment.unix(item?.created_at).format("DD/MM/YYYY hh:mm")}
              {item.status === "TOKEN ACTIVE" && (
                <div className="atvcw-view-details-btn">
                  <PrimaryButton
                    title="View details"
                    handleButtonClick={() => onhandleViewDetails(item)}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="abha-token-view-table-cell-container">
      {window.innerWidth > 768
        ? abhaTokenViewTableCellUi()
        : abhaTokenViewTableCellMobileUi()}
    </div>
  );
};

// export ⇒

export default AbhaTokenViewTableCell;
